import { queryOptions } from "@tanstack/vue-query";
import { client as _heyApiClient } from "./client.gen";
import {
  accountingBook,
  accountingBookingDelete,
  accountingBookingUpdate,
  accountingReportTemplateCreate,
  accountingReportTemplateList,
  accountingReportTemplateStructureFoldersUpdate,
  accountingReportTemplateStructureGet,
  accountingReportTemplateUpdate,
  addRecordCategories,
  categories,
  category,
  categoryCreate,
  categoryDelete,
  categoryUpdate,
  countRecordsForTemplates,
  createDraftSet,
  createFileFolder,
  currentUserUpdate,
  customSequenceCreate,
  customSequenceDelete,
  customSequenceGet,
  customSequenceList,
  customSequenceUpdate,
  deleteFile,
  deleteFileFolder,
  diplomatGet,
  diplomatList,
  discardDraftSet,
  downloadFile,
  downloadFileSignedUrl,
  draftSet,
  eventsTicketCreate,
  field,
  fieldCreate,
  fieldDelete,
  fieldGroupCreate,
  fieldGroupDelete,
  fieldGroupFilterForOrganization,
  fieldGroupSingle,
  fieldGroupUpdate,
  fieldLocatedIn,
  fields,
  fieldUpdate,
  fileCopyCancel,
  fileCopyInitialize,
  fileCopyQuery,
  fileCreateBlank,
  fileEditorOoCallback,
  fileEditorOoConfig,
  fileGet,
  fileGetVersions,
  fileMove,
  fileRelocateCancel,
  fileRelocateInitialize,
  fileRelocateQuery,
  fileRestoreVersion,
  fileUpdateVersionNote,
  filter,
  filterCreate,
  filterDelete,
  filterOrdersUpdate,
  filters,
  filtersetIndividualPermissionCreate,
  filtersetIndividualPermissionDelete,
  filtersetIndividualPermissionList,
  filtersetIndividualPermissionUpdate,
  filterTemplateVisibility,
  filterTemplateVisibilityUpdate,
  filterUpdate,
  forMe,
  getRecordOrigin,
  getTemplateFeaturesForRecord,
  googleOauthCallback,
  googleOauthInit,
  healthy,
  initializeFileUpload,
  initializeRecordAvatarUpload,
  initializeUserAvatarUpload,
  layoutSectionGroupCreate,
  layoutSectionGroupDelete,
  layoutSectionGroupGet,
  layoutSectionGroupList,
  layoutSectionGroupUpdate,
  listRecordAccessRights,
  listRecordUsers,
  microsoftGraphLifecycle,
  microsoftGraphNotifications,
  moduleChildFolderCreate,
  moduleCreate,
  moduleDelete,
  moduleFields,
  moduleFolderDelete,
  moduleFoldersStructure,
  moduleFolderStructure,
  moduleFolderTemplateAppend,
  moduleFolderTemplateDelete,
  moduleFolderTemplateUpdate,
  moduleFolderUpdate,
  modulePermissionGrant,
  modulePermissionGrantAll,
  modulePermissionRevoke,
  moduleRelationsGet,
  moduleRelationsUpdate,
  moduleRootFolderCreate,
  modules,
  moduleSettingGet,
  moduleSettingsGet,
  moduleSettingsUpdate,
  moduleTemplatesPermissionGrantAll,
  moduleUpdate,
  organization,
  organizationAccount,
  organizationAccounts,
  organizationBookings,
  organizationCreate,
  organizationDelete,
  organizationList,
  organizationTree,
  organizationTreeForTenant,
  organizationUpdate,
  performFileUpload,
  productPriceDelete,
  productPriceMostRelevant,
  productPricesList,
  productPriceUpsert,
  proxyImage,
  record,
  recordActionApply,
  recordActionClassify,
  recordActionCreateFrom,
  recordAssignmentCreate,
  recordAssignmentDelete,
  recordAssignments,
  recordAssignmentUpdate,
  recordBookings,
  recordCreate,
  recordEvents,
  recordExplicitRelationCreate,
  recordExplicitRelationDelete,
  recordExplicitRelationList,
  recordExplicitRelationUpdate,
  recordFilesPermissionUpdate,
  recordFollowupList,
  recordIndividualPermissionCreate,
  recordIndividualPermissionDelete,
  recordIndividualPermissionList,
  recordIndividualPermissionUpdate,
  recordPriority,
  recordPriorityCreate,
  recordPriorityDelete,
  recordPrioritySet,
  recordPrioritySetCreate,
  recordPrioritySetDelete,
  recordPrioritySetPriorities,
  recordPrioritySetPriorityCreate,
  recordPrioritySetUpdate,
  recordPriorityUpdate,
  records,
  recordsAggregate,
  recordsCount,
  recordsDelete,
  recordsMinimal,
  recordsPurge,
  recordsRestore,
  recordStatus,
  recordStatusCreate,
  recordStatusDelete,
  recordStatusSet,
  recordStatusSetCreate,
  recordStatusSetDelete,
  recordStatusSetStatusCreate,
  recordStatusSetStatuses,
  recordStatusSetUpdate,
  recordStatusUpdate,
  recordUpdate,
  recordVersions,
  removeRecordCategories,
  roleCreate,
  roleListForOrganization,
  roleListForTenant,
  rolePermission,
  roleRemove,
  roleUpdate,
  roleUserList,
  settingGet,
  settingPermissionGrant,
  settingPermissionGrantAll,
  settingPermissionRevoke,
  settingsGet,
  simpleTenantUpdate,
  systemSettingGet,
  systemSettings,
  tagCreate,
  tagDelete,
  tags,
  tagUpdate,
  template,
  templateCopy,
  templateCreate,
  templateDelete,
  templateKindCopy,
  templateKindCreate,
  templateKindDelete,
  templateKindGet,
  templateKindList,
  templateKindSectionList,
  templateKindSectionUpsert,
  templateKindUpdate,
  templatePatch,
  templatePermissionGrant,
  templatePermissionGrantAll,
  templatePermissionRevoke,
  templateRecordPriorities,
  templateRecordStatuses,
  templates,
  templateSectionCreate,
  templateSectionDelete,
  templateSectionFieldBlockCreate,
  templateSectionFieldBlockDelete,
  templateSectionFieldBlockGet,
  templateSectionFieldBlockList,
  templateSectionFieldBlockUpdate,
  templateSectionGet,
  templateSectionList,
  templateSectionUpdate,
  templateUpdate,
  tenant,
  tenantAccounts,
  tenantAccountSeed,
  tenantBookings,
  tenantConfigCheck,
  tenantConfigCreate,
  tenantConfigDelete,
  tenantConfigGet,
  tenantConfigList,
  tenantConfigUpdate,
  tenantCopyStructure,
  tenantCreate,
  tenantManagementInitialize,
  tenantRecordPrioritySetCreate,
  tenantRecordPrioritySets,
  tenantRecordStatusSetCreate,
  tenantRecordStatusSets,
  tenantsForMe,
  tenantsList,
  tenantUpdate,
  tenantUsage,
  treeFolder,
  updateFileFolder,
  updateRecordUpdatedMetadata,
  userCreate,
  userDelete,
  userGet,
  usergroupAdd,
  usergroupById,
  userGroupList,
  usergroupMemberList,
  usergroupMembersModify,
  usergroupRemove,
  usergroupRoleList,
  usergroupRolesModify,
  usergroupsForTenant,
  usergroupUpdate,
  userMe,
  userRoleChange,
  userRoleList,
  userSecrets,
  userSettingGet,
  userSettingsGet,
  userSettingsUpdate,
  userSettingUpdate,
  usersForTenant,
  userUpdate,
  vatRate,
  vatRateCreate,
  vatRates,
  vatRatesDelete,
  vatRateUpdate
} from "./sdk.gen";
const createQueryKey = (id, options, infinite) => {
  const params = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl
  };
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};
const accountingReportTemplateListQueryKey = (options) => createQueryKey("accountingReportTemplateList", options);
const accountingReportTemplateListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountingReportTemplateList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: accountingReportTemplateListQueryKey(options)
  });
};
const accountingReportTemplateCreateQueryKey = (options) => createQueryKey("accountingReportTemplateCreate", options);
const accountingReportTemplateCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountingReportTemplateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: accountingReportTemplateCreateQueryKey(options)
  });
};
const accountingReportTemplateCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await accountingReportTemplateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const accountingReportTemplateUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await accountingReportTemplateUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const accountingReportTemplateStructureGetQueryKey = (options) => createQueryKey("accountingReportTemplateStructureGet", options);
const accountingReportTemplateStructureGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountingReportTemplateStructureGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: accountingReportTemplateStructureGetQueryKey(options)
  });
};
const accountingReportTemplateStructureFoldersUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await accountingReportTemplateStructureFoldersUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const healthyQueryKey = (options) => createQueryKey("healthy", options);
const healthyOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: healthyQueryKey(options)
  });
};
const systemSettingsQueryKey = (options) => createQueryKey("systemSettings", options);
const systemSettingsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await systemSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: systemSettingsQueryKey(options)
  });
};
const systemSettingGetQueryKey = (options) => createQueryKey("systemSettingGet", options);
const systemSettingGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await systemSettingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: systemSettingGetQueryKey(options)
  });
};
const recordBookingsQueryKey = (options) => createQueryKey("recordBookings", options);
const recordBookingsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordBookings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordBookingsQueryKey(options)
  });
};
const recordBookingsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordBookings({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const categoryDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await categoryDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const categoryCreateQueryKey = (options) => createQueryKey("categoryCreate", options);
const categoryCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await categoryCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: categoryCreateQueryKey(options)
  });
};
const categoryCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await categoryCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const categoryUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await categoryUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const categoriesQueryKey = (options) => createQueryKey("categories", options);
const categoriesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await categories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: categoriesQueryKey(options)
  });
};
const categoriesMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await categories({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const categoryQueryKey = (options) => createQueryKey("category", options);
const categoryOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await category({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: categoryQueryKey(options)
  });
};
const eventsTicketCreateQueryKey = (options) => createQueryKey("eventsTicketCreate", options);
const eventsTicketCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await eventsTicketCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: eventsTicketCreateQueryKey(options)
  });
};
const eventsTicketCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await eventsTicketCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const diplomatListQueryKey = (options) => createQueryKey("diplomatList", options);
const diplomatListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await diplomatList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: diplomatListQueryKey(options)
  });
};
const diplomatListMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await diplomatList({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const diplomatGetQueryKey = (options) => createQueryKey("diplomatGet", options);
const diplomatGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await diplomatGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: diplomatGetQueryKey(options)
  });
};
const fieldDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldQueryKey = (options) => createQueryKey("field", options);
const fieldOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await field({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldQueryKey(options)
  });
};
const fieldCreateQueryKey = (options) => createQueryKey("fieldCreate", options);
const fieldCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fieldCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldCreateQueryKey(options)
  });
};
const fieldCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldsQueryKey = (options) => createQueryKey("fields", options);
const fieldsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fields({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldsQueryKey(options)
  });
};
const fieldsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fields({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldLocatedInQueryKey = (options) => createQueryKey("fieldLocatedIn", options);
const fieldLocatedInOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fieldLocatedIn({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldLocatedInQueryKey(options)
  });
};
const fieldGroupDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldGroupDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldGroupSingleQueryKey = (options) => createQueryKey("fieldGroupSingle", options);
const fieldGroupSingleOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fieldGroupSingle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldGroupSingleQueryKey(options)
  });
};
const fieldGroupCreateQueryKey = (options) => createQueryKey("fieldGroupCreate", options);
const fieldGroupCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fieldGroupCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldGroupCreateQueryKey(options)
  });
};
const fieldGroupCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldGroupCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldGroupUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldGroupUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fieldGroupFilterForOrganizationQueryKey = (options) => createQueryKey("fieldGroupFilterForOrganization", options);
const fieldGroupFilterForOrganizationOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fieldGroupFilterForOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fieldGroupFilterForOrganizationQueryKey(options)
  });
};
const fieldGroupFilterForOrganizationMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fieldGroupFilterForOrganization({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileCreateBlankQueryKey = (options) => createQueryKey("fileCreateBlank", options);
const fileCreateBlankOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileCreateBlank({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileCreateBlankQueryKey(options)
  });
};
const fileCreateBlankMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileCreateBlank({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileCopyInitializeQueryKey = (options) => createQueryKey("fileCopyInitialize", options);
const fileCopyInitializeOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileCopyInitialize({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileCopyInitializeQueryKey(options)
  });
};
const fileCopyInitializeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileCopyInitialize({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileCopyCancelMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileCopyCancel({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileCopyQueryQueryKey = (options) => createQueryKey("fileCopyQuery", options);
const fileCopyQueryOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileCopyQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileCopyQueryQueryKey(options)
  });
};
const createFileFolderQueryKey = (options) => createQueryKey("createFileFolder", options);
const createFileFolderOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createFileFolder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: createFileFolderQueryKey(options)
  });
};
const createFileFolderMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await createFileFolder({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const deleteFileFolderMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteFileFolder({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const updateFileFolderMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await updateFileFolder({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const treeFolderQueryKey = (options) => createQueryKey("treeFolder", options);
const treeFolderOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await treeFolder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: treeFolderQueryKey(options)
  });
};
const treeFolderMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await treeFolder({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileMoveQueryKey = (options) => createQueryKey("fileMove", options);
const fileMoveOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileMove({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileMoveQueryKey(options)
  });
};
const fileMoveMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileMove({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileRelocateInitializeQueryKey = (options) => createQueryKey("fileRelocateInitialize", options);
const fileRelocateInitializeOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileRelocateInitialize({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileRelocateInitializeQueryKey(options)
  });
};
const fileRelocateInitializeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileRelocateInitialize({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileRelocateCancelMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileRelocateCancel({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileRelocateQueryQueryKey = (options) => createQueryKey("fileRelocateQuery", options);
const fileRelocateQueryOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileRelocateQuery({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileRelocateQueryQueryKey(options)
  });
};
const initializeFileUploadQueryKey = (options) => createQueryKey("initializeFileUpload", options);
const initializeFileUploadOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await initializeFileUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: initializeFileUploadQueryKey(options)
  });
};
const initializeFileUploadMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await initializeFileUpload({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const downloadFileSignedUrlQueryKey = (options) => createQueryKey("downloadFileSignedUrl", options);
const downloadFileSignedUrlOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await downloadFileSignedUrl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: downloadFileSignedUrlQueryKey(options)
  });
};
const deleteFileMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteFile({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const downloadFileQueryKey = (options) => createQueryKey("downloadFile", options);
const downloadFileOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await downloadFile({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: downloadFileQueryKey(options)
  });
};
const performFileUploadMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await performFileUpload({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileGetQueryKey = (options) => createQueryKey("fileGet", options);
const fileGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileGetQueryKey(options)
  });
};
const fileEditorOoConfigQueryKey = (options) => createQueryKey("fileEditorOoConfig", options);
const fileEditorOoConfigOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileEditorOoConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileEditorOoConfigQueryKey(options)
  });
};
const fileGetVersionsQueryKey = (options) => createQueryKey("fileGetVersions", options);
const fileGetVersionsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileGetVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileGetVersionsQueryKey(options)
  });
};
const fileGetVersionsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileGetVersions({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileUpdateVersionNoteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileUpdateVersionNote({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileRestoreVersionQueryKey = (options) => createQueryKey("fileRestoreVersion", options);
const fileRestoreVersionOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileRestoreVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileRestoreVersionQueryKey(options)
  });
};
const fileRestoreVersionMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileRestoreVersion({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filterDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filterDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filterCreateQueryKey = (options) => createQueryKey("filterCreate", options);
const filterCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await filterCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: filterCreateQueryKey(options)
  });
};
const filterCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filterCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filterUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filterUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filtersQueryKey = (options) => createQueryKey("filters", options);
const filtersOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await filters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: filtersQueryKey(options)
  });
};
const filtersMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filters({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filterOrdersUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filterOrdersUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filterTemplateVisibilityQueryKey = (options) => createQueryKey("filterTemplateVisibility", options);
const filterTemplateVisibilityOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await filterTemplateVisibility({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: filterTemplateVisibilityQueryKey(options)
  });
};
const filterTemplateVisibilityUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filterTemplateVisibilityUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filterQueryKey = (options) => createQueryKey("filter", options);
const filterOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await filter({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: filterQueryKey(options)
  });
};
const googleOauthCallbackQueryKey = (options) => createQueryKey("googleOauthCallback", options);
const googleOauthCallbackOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await googleOauthCallback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: googleOauthCallbackQueryKey(options)
  });
};
const googleOauthInitQueryKey = (options) => createQueryKey("googleOauthInit", options);
const googleOauthInitOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await googleOauthInit({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: googleOauthInitQueryKey(options)
  });
};
const usergroupAddQueryKey = (options) => createQueryKey("usergroupAdd", options);
const usergroupAddOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usergroupAdd({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: usergroupAddQueryKey(options)
  });
};
const usergroupAddMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await usergroupAdd({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const usergroupUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await usergroupUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const usergroupRemoveMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await usergroupRemove({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const usergroupByIdQueryKey = (options) => createQueryKey("usergroupById", options);
const usergroupByIdOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usergroupById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: usergroupByIdQueryKey(options)
  });
};
const usergroupMemberListQueryKey = (options) => createQueryKey("usergroupMemberList", options);
const usergroupMemberListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usergroupMemberList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: usergroupMemberListQueryKey(options)
  });
};
const usergroupMembersModifyMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await usergroupMembersModify({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const usergroupRoleListQueryKey = (options) => createQueryKey("usergroupRoleList", options);
const usergroupRoleListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usergroupRoleList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: usergroupRoleListQueryKey(options)
  });
};
const usergroupRolesModifyMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await usergroupRolesModify({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const fileEditorOoCallbackQueryKey = (options) => createQueryKey("fileEditorOoCallback", options);
const fileEditorOoCallbackOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await fileEditorOoCallback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: fileEditorOoCallbackQueryKey(options)
  });
};
const fileEditorOoCallbackMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await fileEditorOoCallback({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const microsoftGraphLifecycleQueryKey = (options) => createQueryKey("microsoftGraphLifecycle", options);
const microsoftGraphLifecycleOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await microsoftGraphLifecycle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: microsoftGraphLifecycleQueryKey(options)
  });
};
const microsoftGraphLifecycleMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await microsoftGraphLifecycle({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const microsoftGraphNotificationsQueryKey = (options) => createQueryKey("microsoftGraphNotifications", options);
const microsoftGraphNotificationsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await microsoftGraphNotifications({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: microsoftGraphNotificationsQueryKey(options)
  });
};
const microsoftGraphNotificationsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await microsoftGraphNotifications({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleCreateQueryKey = (options) => createQueryKey("moduleCreate", options);
const moduleCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleCreateQueryKey(options)
  });
};
const moduleCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const modulesQueryKey = (options) => createQueryKey("modules", options);
const modulesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await modules({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: modulesQueryKey(options)
  });
};
const moduleFieldsQueryKey = (options) => createQueryKey("moduleFields", options);
const moduleFieldsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleFields({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleFieldsQueryKey(options)
  });
};
const moduleRelationsGetQueryKey = (options) => createQueryKey("moduleRelationsGet", options);
const moduleRelationsGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleRelationsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleRelationsGetQueryKey(options)
  });
};
const moduleRelationsUpdateQueryKey = (options) => createQueryKey("moduleRelationsUpdate", options);
const moduleRelationsUpdateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleRelationsUpdate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleRelationsUpdateQueryKey(options)
  });
};
const moduleRelationsUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleRelationsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleSettingsGetQueryKey = (options) => createQueryKey("moduleSettingsGet", options);
const moduleSettingsGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleSettingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleSettingsGetQueryKey(options)
  });
};
const moduleSettingsUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleSettingsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleSettingGetQueryKey = (options) => createQueryKey("moduleSettingGet", options);
const moduleSettingGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleSettingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleSettingGetQueryKey(options)
  });
};
const moduleFolderDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFolderDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleChildFolderCreateQueryKey = (options) => createQueryKey("moduleChildFolderCreate", options);
const moduleChildFolderCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleChildFolderCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleChildFolderCreateQueryKey(options)
  });
};
const moduleChildFolderCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleChildFolderCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleFolderUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFolderUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleFolderStructureQueryKey = (options) => createQueryKey("moduleFolderStructure", options);
const moduleFolderStructureOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleFolderStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleFolderStructureQueryKey(options)
  });
};
const moduleFolderStructureMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFolderStructure({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleFolderTemplateDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFolderTemplateDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleFolderTemplateAppendQueryKey = (options) => createQueryKey("moduleFolderTemplateAppend", options);
const moduleFolderTemplateAppendOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleFolderTemplateAppend({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleFolderTemplateAppendQueryKey(options)
  });
};
const moduleFolderTemplateAppendMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFolderTemplateAppend({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleFolderTemplateUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFolderTemplateUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleRootFolderCreateQueryKey = (options) => createQueryKey("moduleRootFolderCreate", options);
const moduleRootFolderCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleRootFolderCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleRootFolderCreateQueryKey(options)
  });
};
const moduleRootFolderCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleRootFolderCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleFoldersStructureQueryKey = (options) => createQueryKey("moduleFoldersStructure", options);
const moduleFoldersStructureOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await moduleFoldersStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: moduleFoldersStructureQueryKey(options)
  });
};
const moduleFoldersStructureMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleFoldersStructure({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const organizationDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await organizationDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const organizationQueryKey = (options) => createQueryKey("organization", options);
const organizationOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationQueryKey(options)
  });
};
const organizationCreateQueryKey = (options) => createQueryKey("organizationCreate", options);
const organizationCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationCreateQueryKey(options)
  });
};
const organizationCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await organizationCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const organizationUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await organizationUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const organizationListQueryKey = (options) => createQueryKey("organizationList", options);
const organizationListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationListQueryKey(options)
  });
};
const organizationTreeQueryKey = (options) => createQueryKey("organizationTree", options);
const organizationTreeOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationTree({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationTreeQueryKey(options)
  });
};
const organizationTreeForTenantQueryKey = (options) => createQueryKey("organizationTreeForTenant", options);
const organizationTreeForTenantOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationTreeForTenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationTreeForTenantQueryKey(options)
  });
};
const organizationAccountsQueryKey = (options) => createQueryKey("organizationAccounts", options);
const organizationAccountsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationAccountsQueryKey(options)
  });
};
const organizationAccountsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await organizationAccounts({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const organizationAccountQueryKey = (options) => createQueryKey("organizationAccount", options);
const organizationAccountOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationAccountQueryKey(options)
  });
};
const organizationBookingsQueryKey = (options) => createQueryKey("organizationBookings", options);
const organizationBookingsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await organizationBookings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: organizationBookingsQueryKey(options)
  });
};
const organizationBookingsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await organizationBookings({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filtersetIndividualPermissionCreateQueryKey = (options) => createQueryKey("filtersetIndividualPermissionCreate", options);
const filtersetIndividualPermissionCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await filtersetIndividualPermissionCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: filtersetIndividualPermissionCreateQueryKey(options)
  });
};
const filtersetIndividualPermissionCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filtersetIndividualPermissionCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filtersetIndividualPermissionListQueryKey = (options) => createQueryKey("filtersetIndividualPermissionList", options);
const filtersetIndividualPermissionListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await filtersetIndividualPermissionList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: filtersetIndividualPermissionListQueryKey(options)
  });
};
const filtersetIndividualPermissionListMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filtersetIndividualPermissionList({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filtersetIndividualPermissionDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filtersetIndividualPermissionDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const filtersetIndividualPermissionUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await filtersetIndividualPermissionUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const forMeQueryKey = (options) => createQueryKey("forMe", options);
const forMeOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await forMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: forMeQueryKey(options)
  });
};
const recordIndividualPermissionCreateQueryKey = (options) => createQueryKey("recordIndividualPermissionCreate", options);
const recordIndividualPermissionCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordIndividualPermissionCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordIndividualPermissionCreateQueryKey(options)
  });
};
const recordIndividualPermissionCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordIndividualPermissionCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordIndividualPermissionListQueryKey = (options) => createQueryKey("recordIndividualPermissionList", options);
const recordIndividualPermissionListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordIndividualPermissionList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordIndividualPermissionListQueryKey(options)
  });
};
const recordIndividualPermissionListMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordIndividualPermissionList({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordIndividualPermissionDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordIndividualPermissionDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordIndividualPermissionUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordIndividualPermissionUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const rolePermissionQueryKey = (options) => createQueryKey("rolePermission", options);
const rolePermissionOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await rolePermission({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: rolePermissionQueryKey(options)
  });
};
const modulePermissionRevokeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await modulePermissionRevoke({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const modulePermissionGrantMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await modulePermissionGrant({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const moduleTemplatesPermissionGrantAllMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await moduleTemplatesPermissionGrantAll({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const modulePermissionGrantAllMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await modulePermissionGrantAll({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const settingPermissionRevokeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await settingPermissionRevoke({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const settingPermissionGrantMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await settingPermissionGrant({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const settingPermissionGrantAllMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await settingPermissionGrantAll({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templatePermissionRevokeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templatePermissionRevoke({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templatePermissionGrantMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templatePermissionGrant({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templatePermissionGrantAllMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templatePermissionGrantAll({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const productPriceUpsertQueryKey = (options) => createQueryKey("productPriceUpsert", options);
const productPriceUpsertOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productPriceUpsert({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: productPriceUpsertQueryKey(options)
  });
};
const productPriceUpsertMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await productPriceUpsert({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const productPricesListQueryKey = (options) => createQueryKey("productPricesList", options);
const productPricesListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productPricesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: productPricesListQueryKey(options)
  });
};
const productPricesListMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await productPricesList({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const productPriceMostRelevantQueryKey = (options) => createQueryKey("productPriceMostRelevant", options);
const productPriceMostRelevantOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productPriceMostRelevant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: productPriceMostRelevantQueryKey(options)
  });
};
const productPriceDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await productPriceDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const proxyImageQueryKey = (options) => createQueryKey("proxyImage", options);
const proxyImageOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await proxyImage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: proxyImageQueryKey(options)
  });
};
const recordsDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordsDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordQueryKey = (options) => createQueryKey("record", options);
const recordOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await record({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordQueryKey(options)
  });
};
const recordCreateQueryKey = (options) => createQueryKey("recordCreate", options);
const recordCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordCreateQueryKey(options)
  });
};
const recordCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const createDraftSetQueryKey = (options) => createQueryKey("createDraftSet", options);
const createDraftSetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createDraftSet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: createDraftSetQueryKey(options)
  });
};
const createDraftSetMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await createDraftSet({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const discardDraftSetMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await discardDraftSet({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const draftSetQueryKey = (options) => createQueryKey("draftSet", options);
const draftSetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await draftSet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: draftSetQueryKey(options)
  });
};
const recordsQueryKey = (options) => createQueryKey("records", options);
const recordsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await records({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordsQueryKey(options)
  });
};
const recordsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await records({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordsAggregateQueryKey = (options) => createQueryKey("recordsAggregate", options);
const recordsAggregateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordsAggregate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordsAggregateQueryKey(options)
  });
};
const recordsAggregateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordsAggregate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordsCountQueryKey = (options) => createQueryKey("recordsCount", options);
const recordsCountOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordsCount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordsCountQueryKey(options)
  });
};
const recordsCountMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordsCount({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordsMinimalQueryKey = (options) => createQueryKey("recordsMinimal", options);
const recordsMinimalOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordsMinimal({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordsMinimalQueryKey(options)
  });
};
const recordsMinimalMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordsMinimal({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const countRecordsForTemplatesQueryKey = (options) => createQueryKey("countRecordsForTemplates", options);
const countRecordsForTemplatesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await countRecordsForTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: countRecordsForTemplatesQueryKey(options)
  });
};
const countRecordsForTemplatesMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await countRecordsForTemplates({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordsPurgeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordsPurge({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordsRestoreQueryKey = (options) => createQueryKey("recordsRestore", options);
const recordsRestoreOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordsRestore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordsRestoreQueryKey(options)
  });
};
const recordsRestoreMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordsRestore({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const listRecordAccessRightsQueryKey = (options) => createQueryKey("listRecordAccessRights", options);
const listRecordAccessRightsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRecordAccessRights({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listRecordAccessRightsQueryKey(options)
  });
};
const listRecordAccessRightsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await listRecordAccessRights({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const initializeRecordAvatarUploadQueryKey = (options) => createQueryKey("initializeRecordAvatarUpload", options);
const initializeRecordAvatarUploadOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await initializeRecordAvatarUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: initializeRecordAvatarUploadQueryKey(options)
  });
};
const initializeRecordAvatarUploadMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await initializeRecordAvatarUpload({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordEventsQueryKey = (options) => createQueryKey("recordEvents", options);
const recordEventsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordEvents({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordEventsQueryKey(options)
  });
};
const recordEventsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordEvents({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordFilesPermissionUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordFilesPermissionUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const updateRecordUpdatedMetadataMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await updateRecordUpdatedMetadata({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const getRecordOriginQueryKey = (options) => createQueryKey("getRecordOrigin", options);
const getRecordOriginOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRecordOrigin({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getRecordOriginQueryKey(options)
  });
};
const getTemplateFeaturesForRecordQueryKey = (options) => createQueryKey("getTemplateFeaturesForRecord", options);
const getTemplateFeaturesForRecordOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTemplateFeaturesForRecord({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: getTemplateFeaturesForRecordQueryKey(options)
  });
};
const listRecordUsersQueryKey = (options) => createQueryKey("listRecordUsers", options);
const listRecordUsersOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRecordUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: listRecordUsersQueryKey(options)
  });
};
const listRecordUsersMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await listRecordUsers({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPriorityCreateQueryKey = (options) => createQueryKey("recordPriorityCreate", options);
const recordPriorityCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordPriorityCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordPriorityCreateQueryKey(options)
  });
};
const recordPriorityCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPriorityCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPriorityDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPriorityDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPriorityQueryKey = (options) => createQueryKey("recordPriority", options);
const recordPriorityOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordPriority({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordPriorityQueryKey(options)
  });
};
const recordPriorityUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPriorityUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPrioritySetCreateQueryKey = (options) => createQueryKey("recordPrioritySetCreate", options);
const recordPrioritySetCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordPrioritySetCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordPrioritySetCreateQueryKey(options)
  });
};
const recordPrioritySetCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPrioritySetCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPrioritySetDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPrioritySetDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPrioritySetQueryKey = (options) => createQueryKey("recordPrioritySet", options);
const recordPrioritySetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordPrioritySet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordPrioritySetQueryKey(options)
  });
};
const recordPrioritySetUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPrioritySetUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordPrioritySetPrioritiesQueryKey = (options) => createQueryKey("recordPrioritySetPriorities", options);
const recordPrioritySetPrioritiesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordPrioritySetPriorities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordPrioritySetPrioritiesQueryKey(options)
  });
};
const recordPrioritySetPriorityCreateQueryKey = (options) => createQueryKey("recordPrioritySetPriorityCreate", options);
const recordPrioritySetPriorityCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordPrioritySetPriorityCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordPrioritySetPriorityCreateQueryKey(options)
  });
};
const recordPrioritySetPriorityCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordPrioritySetPriorityCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordActionClassifyQueryKey = (options) => createQueryKey("recordActionClassify", options);
const recordActionClassifyOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordActionClassify({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordActionClassifyQueryKey(options)
  });
};
const recordActionClassifyMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordActionClassify({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordActionCreateFromQueryKey = (options) => createQueryKey("recordActionCreateFrom", options);
const recordActionCreateFromOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordActionCreateFrom({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordActionCreateFromQueryKey(options)
  });
};
const recordActionCreateFromMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordActionCreateFrom({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordAssignmentDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordAssignmentDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordAssignmentUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordAssignmentUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordExplicitRelationDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordExplicitRelationDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordExplicitRelationUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordExplicitRelationUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordVersionsQueryKey = (options) => createQueryKey("recordVersions", options);
const recordVersionsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordVersionsQueryKey(options)
  });
};
const recordVersionsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordVersions({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordActionApplyQueryKey = (options) => createQueryKey("recordActionApply", options);
const recordActionApplyOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordActionApply({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordActionApplyQueryKey(options)
  });
};
const recordActionApplyMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordActionApply({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordAssignmentCreateQueryKey = (options) => createQueryKey("recordAssignmentCreate", options);
const recordAssignmentCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordAssignmentCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordAssignmentCreateQueryKey(options)
  });
};
const recordAssignmentCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordAssignmentCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordAssignmentsQueryKey = (options) => createQueryKey("recordAssignments", options);
const recordAssignmentsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordAssignments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordAssignmentsQueryKey(options)
  });
};
const recordAssignmentsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordAssignments({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const removeRecordCategoriesMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await removeRecordCategories({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const addRecordCategoriesQueryKey = (options) => createQueryKey("addRecordCategories", options);
const addRecordCategoriesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addRecordCategories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: addRecordCategoriesQueryKey(options)
  });
};
const addRecordCategoriesMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await addRecordCategories({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordExplicitRelationCreateQueryKey = (options) => createQueryKey("recordExplicitRelationCreate", options);
const recordExplicitRelationCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordExplicitRelationCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordExplicitRelationCreateQueryKey(options)
  });
};
const recordExplicitRelationCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordExplicitRelationCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordExplicitRelationListQueryKey = (options) => createQueryKey("recordExplicitRelationList", options);
const recordExplicitRelationListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordExplicitRelationList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordExplicitRelationListQueryKey(options)
  });
};
const recordExplicitRelationListMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordExplicitRelationList({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordFollowupListQueryKey = (options) => createQueryKey("recordFollowupList", options);
const recordFollowupListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordFollowupList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordFollowupListQueryKey(options)
  });
};
const recordFollowupListMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordFollowupList({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusCreateQueryKey = (options) => createQueryKey("recordStatusCreate", options);
const recordStatusCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordStatusCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordStatusCreateQueryKey(options)
  });
};
const recordStatusCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusQueryKey = (options) => createQueryKey("recordStatus", options);
const recordStatusOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordStatusQueryKey(options)
  });
};
const recordStatusUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusSetCreateQueryKey = (options) => createQueryKey("recordStatusSetCreate", options);
const recordStatusSetCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordStatusSetCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordStatusSetCreateQueryKey(options)
  });
};
const recordStatusSetCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusSetCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusSetDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusSetDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusSetQueryKey = (options) => createQueryKey("recordStatusSet", options);
const recordStatusSetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordStatusSet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordStatusSetQueryKey(options)
  });
};
const recordStatusSetUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusSetUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const recordStatusSetStatusesQueryKey = (options) => createQueryKey("recordStatusSetStatuses", options);
const recordStatusSetStatusesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordStatusSetStatuses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordStatusSetStatusesQueryKey(options)
  });
};
const recordStatusSetStatusCreateQueryKey = (options) => createQueryKey("recordStatusSetStatusCreate", options);
const recordStatusSetStatusCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recordStatusSetStatusCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: recordStatusSetStatusCreateQueryKey(options)
  });
};
const recordStatusSetStatusCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await recordStatusSetStatusCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const roleCreateQueryKey = (options) => createQueryKey("roleCreate", options);
const roleCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await roleCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: roleCreateQueryKey(options)
  });
};
const roleCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await roleCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const roleUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await roleUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const roleListForOrganizationQueryKey = (options) => createQueryKey("roleListForOrganization", options);
const roleListForOrganizationOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await roleListForOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: roleListForOrganizationQueryKey(options)
  });
};
const roleListForTenantQueryKey = (options) => createQueryKey("roleListForTenant", options);
const roleListForTenantOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await roleListForTenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: roleListForTenantQueryKey(options)
  });
};
const roleRemoveMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await roleRemove({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const roleUserListQueryKey = (options) => createQueryKey("roleUserList", options);
const roleUserListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await roleUserList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: roleUserListQueryKey(options)
  });
};
const settingsGetQueryKey = (options) => createQueryKey("settingsGet", options);
const settingsGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: settingsGetQueryKey(options)
  });
};
const settingGetQueryKey = (options) => createQueryKey("settingGet", options);
const settingGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: settingGetQueryKey(options)
  });
};
const tagDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tagDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tagCreateQueryKey = (options) => createQueryKey("tagCreate", options);
const tagCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tagCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tagCreateQueryKey(options)
  });
};
const tagCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tagCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tagUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tagUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tagsQueryKey = (options) => createQueryKey("tags", options);
const tagsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tags({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tagsQueryKey(options)
  });
};
const tagsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tags({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateQueryKey = (options) => createQueryKey("template", options);
const templateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await template({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateQueryKey(options)
  });
};
const templateCreateQueryKey = (options) => createQueryKey("templateCreate", options);
const templateCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateCreateQueryKey(options)
  });
};
const templateCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templatesQueryKey = (options) => createQueryKey("templates", options);
const templatesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templatesQueryKey(options)
  });
};
const templatesMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templates({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templatePatchMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templatePatch({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateCopyQueryKey = (options) => createQueryKey("templateCopy", options);
const templateCopyOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateCopy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateCopyQueryKey(options)
  });
};
const templateCopyMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateCopy({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateRecordPrioritiesQueryKey = (options) => createQueryKey("templateRecordPriorities", options);
const templateRecordPrioritiesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateRecordPriorities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateRecordPrioritiesQueryKey(options)
  });
};
const templateRecordStatusesQueryKey = (options) => createQueryKey("templateRecordStatuses", options);
const templateRecordStatusesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateRecordStatuses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateRecordStatusesQueryKey(options)
  });
};
const templateSectionFieldBlockDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateSectionFieldBlockDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateSectionFieldBlockGetQueryKey = (options) => createQueryKey("templateSectionFieldBlockGet", options);
const templateSectionFieldBlockGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateSectionFieldBlockGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateSectionFieldBlockGetQueryKey(options)
  });
};
const templateSectionFieldBlockUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateSectionFieldBlockUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateSectionDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateSectionDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateSectionGetQueryKey = (options) => createQueryKey("templateSectionGet", options);
const templateSectionGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateSectionGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateSectionGetQueryKey(options)
  });
};
const templateSectionUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateSectionUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateSectionFieldBlockListQueryKey = (options) => createQueryKey("templateSectionFieldBlockList", options);
const templateSectionFieldBlockListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateSectionFieldBlockList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateSectionFieldBlockListQueryKey(options)
  });
};
const templateSectionFieldBlockCreateQueryKey = (options) => createQueryKey("templateSectionFieldBlockCreate", options);
const templateSectionFieldBlockCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateSectionFieldBlockCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateSectionFieldBlockCreateQueryKey(options)
  });
};
const templateSectionFieldBlockCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateSectionFieldBlockCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateKindListQueryKey = (options) => createQueryKey("templateKindList", options);
const templateKindListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateKindList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateKindListQueryKey(options)
  });
};
const templateKindCreateQueryKey = (options) => createQueryKey("templateKindCreate", options);
const templateKindCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateKindCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateKindCreateQueryKey(options)
  });
};
const templateKindCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateKindCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateKindDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateKindDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateKindGetQueryKey = (options) => createQueryKey("templateKindGet", options);
const templateKindGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateKindGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateKindGetQueryKey(options)
  });
};
const templateKindUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateKindUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateKindCopyQueryKey = (options) => createQueryKey("templateKindCopy", options);
const templateKindCopyOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateKindCopy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateKindCopyQueryKey(options)
  });
};
const templateKindCopyMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateKindCopy({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateKindSectionListQueryKey = (options) => createQueryKey("templateKindSectionList", options);
const templateKindSectionListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateKindSectionList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateKindSectionListQueryKey(options)
  });
};
const templateKindSectionUpsertMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateKindSectionUpsert({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const templateSectionListQueryKey = (options) => createQueryKey("templateSectionList", options);
const templateSectionListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateSectionList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateSectionListQueryKey(options)
  });
};
const templateSectionCreateQueryKey = (options) => createQueryKey("templateSectionCreate", options);
const templateSectionCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await templateSectionCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: templateSectionCreateQueryKey(options)
  });
};
const templateSectionCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await templateSectionCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const simpleTenantUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await simpleTenantUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantsForMeQueryKey = (options) => createQueryKey("tenantsForMe", options);
const tenantsForMeOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantsForMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantsForMeQueryKey(options)
  });
};
const usergroupsForTenantQueryKey = (options) => createQueryKey("usergroupsForTenant", options);
const usergroupsForTenantOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usergroupsForTenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: usergroupsForTenantQueryKey(options)
  });
};
const tenantRecordPrioritySetsQueryKey = (options) => createQueryKey("tenantRecordPrioritySets", options);
const tenantRecordPrioritySetsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantRecordPrioritySets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantRecordPrioritySetsQueryKey(options)
  });
};
const tenantRecordPrioritySetCreateQueryKey = (options) => createQueryKey("tenantRecordPrioritySetCreate", options);
const tenantRecordPrioritySetCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantRecordPrioritySetCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantRecordPrioritySetCreateQueryKey(options)
  });
};
const tenantRecordPrioritySetCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantRecordPrioritySetCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantRecordStatusSetsQueryKey = (options) => createQueryKey("tenantRecordStatusSets", options);
const tenantRecordStatusSetsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantRecordStatusSets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantRecordStatusSetsQueryKey(options)
  });
};
const tenantRecordStatusSetCreateQueryKey = (options) => createQueryKey("tenantRecordStatusSetCreate", options);
const tenantRecordStatusSetCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantRecordStatusSetCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantRecordStatusSetCreateQueryKey(options)
  });
};
const tenantRecordStatusSetCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantRecordStatusSetCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const usersForTenantQueryKey = (options) => createQueryKey("usersForTenant", options);
const usersForTenantOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersForTenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: usersForTenantQueryKey(options)
  });
};
const tenantQueryKey = (options) => createQueryKey("tenant", options);
const tenantOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenant({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantQueryKey(options)
  });
};
const tenantCreateQueryKey = (options) => createQueryKey("tenantCreate", options);
const tenantCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantCreateQueryKey(options)
  });
};
const tenantCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantCopyStructureQueryKey = (options) => createQueryKey("tenantCopyStructure", options);
const tenantCopyStructureOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantCopyStructure({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantCopyStructureQueryKey(options)
  });
};
const tenantCopyStructureMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantCopyStructure({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantManagementInitializeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantManagementInitialize({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantsListQueryKey = (options) => createQueryKey("tenantsList", options);
const tenantsListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantsListQueryKey(options)
  });
};
const tenantUsageQueryKey = (options) => createQueryKey("tenantUsage", options);
const tenantUsageOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantUsage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantUsageQueryKey(options)
  });
};
const tenantConfigCheckQueryKey = (options) => createQueryKey("tenantConfigCheck", options);
const tenantConfigCheckOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantConfigCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantConfigCheckQueryKey(options)
  });
};
const tenantConfigCheckMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantConfigCheck({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantConfigDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantConfigDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantConfigGetQueryKey = (options) => createQueryKey("tenantConfigGet", options);
const tenantConfigGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantConfigGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantConfigGetQueryKey(options)
  });
};
const tenantConfigUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantConfigUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const layoutSectionGroupDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await layoutSectionGroupDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const layoutSectionGroupGetQueryKey = (options) => createQueryKey("layoutSectionGroupGet", options);
const layoutSectionGroupGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await layoutSectionGroupGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: layoutSectionGroupGetQueryKey(options)
  });
};
const layoutSectionGroupUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await layoutSectionGroupUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const customSequenceDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await customSequenceDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const customSequenceGetQueryKey = (options) => createQueryKey("customSequenceGet", options);
const customSequenceGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await customSequenceGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: customSequenceGetQueryKey(options)
  });
};
const customSequenceUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await customSequenceUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const accountingBookQueryKey = (options) => createQueryKey("accountingBook", options);
const accountingBookOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountingBook({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: accountingBookQueryKey(options)
  });
};
const accountingBookMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await accountingBook({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const accountingBookingDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await accountingBookingDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const accountingBookingUpdateQueryKey = (options) => createQueryKey("accountingBookingUpdate", options);
const accountingBookingUpdateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await accountingBookingUpdate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: accountingBookingUpdateQueryKey(options)
  });
};
const accountingBookingUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await accountingBookingUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantAccountsQueryKey = (options) => createQueryKey("tenantAccounts", options);
const tenantAccountsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantAccounts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantAccountsQueryKey(options)
  });
};
const tenantAccountsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantAccounts({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantAccountSeedMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantAccountSeed({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantBookingsQueryKey = (options) => createQueryKey("tenantBookings", options);
const tenantBookingsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantBookings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantBookingsQueryKey(options)
  });
};
const tenantBookingsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantBookings({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const tenantConfigListQueryKey = (options) => createQueryKey("tenantConfigList", options);
const tenantConfigListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantConfigList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantConfigListQueryKey(options)
  });
};
const tenantConfigCreateQueryKey = (options) => createQueryKey("tenantConfigCreate", options);
const tenantConfigCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tenantConfigCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: tenantConfigCreateQueryKey(options)
  });
};
const tenantConfigCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await tenantConfigCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const layoutSectionGroupListQueryKey = (options) => createQueryKey("layoutSectionGroupList", options);
const layoutSectionGroupListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await layoutSectionGroupList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: layoutSectionGroupListQueryKey(options)
  });
};
const layoutSectionGroupCreateQueryKey = (options) => createQueryKey("layoutSectionGroupCreate", options);
const layoutSectionGroupCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await layoutSectionGroupCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: layoutSectionGroupCreateQueryKey(options)
  });
};
const layoutSectionGroupCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await layoutSectionGroupCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const customSequenceListQueryKey = (options) => createQueryKey("customSequenceList", options);
const customSequenceListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await customSequenceList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: customSequenceListQueryKey(options)
  });
};
const customSequenceCreateQueryKey = (options) => createQueryKey("customSequenceCreate", options);
const customSequenceCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await customSequenceCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: customSequenceCreateQueryKey(options)
  });
};
const customSequenceCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await customSequenceCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const vatRateCreateQueryKey = (options) => createQueryKey("vatRateCreate", options);
const vatRateCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vatRateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: vatRateCreateQueryKey(options)
  });
};
const vatRateCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await vatRateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const vatRatesQueryKey = (options) => createQueryKey("vatRates", options);
const vatRatesOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vatRates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: vatRatesQueryKey(options)
  });
};
const vatRatesMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await vatRates({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userMeQueryKey = (options) => createQueryKey("userMe", options);
const userMeOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userMeQueryKey(options)
  });
};
const userCreateQueryKey = (options) => createQueryKey("userCreate", options);
const userCreateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userCreateQueryKey(options)
  });
};
const userCreateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const currentUserUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await currentUserUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userGroupListQueryKey = (options) => createQueryKey("userGroupList", options);
const userGroupListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userGroupList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userGroupListQueryKey(options)
  });
};
const userRoleListQueryKey = (options) => createQueryKey("userRoleList", options);
const userRoleListOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userRoleList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userRoleListQueryKey(options)
  });
};
const userRoleChangeMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userRoleChange({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userSecretsQueryKey = (options) => createQueryKey("userSecrets", options);
const userSecretsOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userSecrets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userSecretsQueryKey(options)
  });
};
const userSecretsMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userSecrets({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userGetQueryKey = (options) => createQueryKey("userGet", options);
const userGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userGetQueryKey(options)
  });
};
const userUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const initializeUserAvatarUploadQueryKey = (options) => createQueryKey("initializeUserAvatarUpload", options);
const initializeUserAvatarUploadOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await initializeUserAvatarUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: initializeUserAvatarUploadQueryKey(options)
  });
};
const initializeUserAvatarUploadMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await initializeUserAvatarUpload({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userSettingsGetQueryKey = (options) => createQueryKey("userSettingsGet", options);
const userSettingsGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userSettingsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userSettingsGetQueryKey(options)
  });
};
const userSettingsUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userSettingsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const userSettingGetQueryKey = (options) => createQueryKey("userSettingGet", options);
const userSettingGetOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await userSettingGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: userSettingGetQueryKey(options)
  });
};
const userSettingUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await userSettingUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const vatRatesDeleteMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await vatRatesDelete({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
const vatRateQueryKey = (options) => createQueryKey("vatRate", options);
const vatRateOptions = (options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await vatRate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      });
      return data;
    },
    queryKey: vatRateQueryKey(options)
  });
};
const vatRateUpdateMutation = (options) => {
  const mutationOptions = {
    mutationFn: async (localOptions) => {
      const { data } = await vatRateUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      });
      return data;
    }
  };
  return mutationOptions;
};
export {
  accountingBookMutation,
  accountingBookOptions,
  accountingBookQueryKey,
  accountingBookingDeleteMutation,
  accountingBookingUpdateMutation,
  accountingBookingUpdateOptions,
  accountingBookingUpdateQueryKey,
  accountingReportTemplateCreateMutation,
  accountingReportTemplateCreateOptions,
  accountingReportTemplateCreateQueryKey,
  accountingReportTemplateListOptions,
  accountingReportTemplateListQueryKey,
  accountingReportTemplateStructureFoldersUpdateMutation,
  accountingReportTemplateStructureGetOptions,
  accountingReportTemplateStructureGetQueryKey,
  accountingReportTemplateUpdateMutation,
  addRecordCategoriesMutation,
  addRecordCategoriesOptions,
  addRecordCategoriesQueryKey,
  categoriesMutation,
  categoriesOptions,
  categoriesQueryKey,
  categoryCreateMutation,
  categoryCreateOptions,
  categoryCreateQueryKey,
  categoryDeleteMutation,
  categoryOptions,
  categoryQueryKey,
  categoryUpdateMutation,
  countRecordsForTemplatesMutation,
  countRecordsForTemplatesOptions,
  countRecordsForTemplatesQueryKey,
  createDraftSetMutation,
  createDraftSetOptions,
  createDraftSetQueryKey,
  createFileFolderMutation,
  createFileFolderOptions,
  createFileFolderQueryKey,
  currentUserUpdateMutation,
  customSequenceCreateMutation,
  customSequenceCreateOptions,
  customSequenceCreateQueryKey,
  customSequenceDeleteMutation,
  customSequenceGetOptions,
  customSequenceGetQueryKey,
  customSequenceListOptions,
  customSequenceListQueryKey,
  customSequenceUpdateMutation,
  deleteFileFolderMutation,
  deleteFileMutation,
  diplomatGetOptions,
  diplomatGetQueryKey,
  diplomatListMutation,
  diplomatListOptions,
  diplomatListQueryKey,
  discardDraftSetMutation,
  downloadFileOptions,
  downloadFileQueryKey,
  downloadFileSignedUrlOptions,
  downloadFileSignedUrlQueryKey,
  draftSetOptions,
  draftSetQueryKey,
  eventsTicketCreateMutation,
  eventsTicketCreateOptions,
  eventsTicketCreateQueryKey,
  fieldCreateMutation,
  fieldCreateOptions,
  fieldCreateQueryKey,
  fieldDeleteMutation,
  fieldGroupCreateMutation,
  fieldGroupCreateOptions,
  fieldGroupCreateQueryKey,
  fieldGroupDeleteMutation,
  fieldGroupFilterForOrganizationMutation,
  fieldGroupFilterForOrganizationOptions,
  fieldGroupFilterForOrganizationQueryKey,
  fieldGroupSingleOptions,
  fieldGroupSingleQueryKey,
  fieldGroupUpdateMutation,
  fieldLocatedInOptions,
  fieldLocatedInQueryKey,
  fieldOptions,
  fieldQueryKey,
  fieldUpdateMutation,
  fieldsMutation,
  fieldsOptions,
  fieldsQueryKey,
  fileCopyCancelMutation,
  fileCopyInitializeMutation,
  fileCopyInitializeOptions,
  fileCopyInitializeQueryKey,
  fileCopyQueryOptions,
  fileCopyQueryQueryKey,
  fileCreateBlankMutation,
  fileCreateBlankOptions,
  fileCreateBlankQueryKey,
  fileEditorOoCallbackMutation,
  fileEditorOoCallbackOptions,
  fileEditorOoCallbackQueryKey,
  fileEditorOoConfigOptions,
  fileEditorOoConfigQueryKey,
  fileGetOptions,
  fileGetQueryKey,
  fileGetVersionsMutation,
  fileGetVersionsOptions,
  fileGetVersionsQueryKey,
  fileMoveMutation,
  fileMoveOptions,
  fileMoveQueryKey,
  fileRelocateCancelMutation,
  fileRelocateInitializeMutation,
  fileRelocateInitializeOptions,
  fileRelocateInitializeQueryKey,
  fileRelocateQueryOptions,
  fileRelocateQueryQueryKey,
  fileRestoreVersionMutation,
  fileRestoreVersionOptions,
  fileRestoreVersionQueryKey,
  fileUpdateVersionNoteMutation,
  filterCreateMutation,
  filterCreateOptions,
  filterCreateQueryKey,
  filterDeleteMutation,
  filterOptions,
  filterOrdersUpdateMutation,
  filterQueryKey,
  filterTemplateVisibilityOptions,
  filterTemplateVisibilityQueryKey,
  filterTemplateVisibilityUpdateMutation,
  filterUpdateMutation,
  filtersMutation,
  filtersOptions,
  filtersQueryKey,
  filtersetIndividualPermissionCreateMutation,
  filtersetIndividualPermissionCreateOptions,
  filtersetIndividualPermissionCreateQueryKey,
  filtersetIndividualPermissionDeleteMutation,
  filtersetIndividualPermissionListMutation,
  filtersetIndividualPermissionListOptions,
  filtersetIndividualPermissionListQueryKey,
  filtersetIndividualPermissionUpdateMutation,
  forMeOptions,
  forMeQueryKey,
  getRecordOriginOptions,
  getRecordOriginQueryKey,
  getTemplateFeaturesForRecordOptions,
  getTemplateFeaturesForRecordQueryKey,
  googleOauthCallbackOptions,
  googleOauthCallbackQueryKey,
  googleOauthInitOptions,
  googleOauthInitQueryKey,
  healthyOptions,
  healthyQueryKey,
  initializeFileUploadMutation,
  initializeFileUploadOptions,
  initializeFileUploadQueryKey,
  initializeRecordAvatarUploadMutation,
  initializeRecordAvatarUploadOptions,
  initializeRecordAvatarUploadQueryKey,
  initializeUserAvatarUploadMutation,
  initializeUserAvatarUploadOptions,
  initializeUserAvatarUploadQueryKey,
  layoutSectionGroupCreateMutation,
  layoutSectionGroupCreateOptions,
  layoutSectionGroupCreateQueryKey,
  layoutSectionGroupDeleteMutation,
  layoutSectionGroupGetOptions,
  layoutSectionGroupGetQueryKey,
  layoutSectionGroupListOptions,
  layoutSectionGroupListQueryKey,
  layoutSectionGroupUpdateMutation,
  listRecordAccessRightsMutation,
  listRecordAccessRightsOptions,
  listRecordAccessRightsQueryKey,
  listRecordUsersMutation,
  listRecordUsersOptions,
  listRecordUsersQueryKey,
  microsoftGraphLifecycleMutation,
  microsoftGraphLifecycleOptions,
  microsoftGraphLifecycleQueryKey,
  microsoftGraphNotificationsMutation,
  microsoftGraphNotificationsOptions,
  microsoftGraphNotificationsQueryKey,
  moduleChildFolderCreateMutation,
  moduleChildFolderCreateOptions,
  moduleChildFolderCreateQueryKey,
  moduleCreateMutation,
  moduleCreateOptions,
  moduleCreateQueryKey,
  moduleDeleteMutation,
  moduleFieldsOptions,
  moduleFieldsQueryKey,
  moduleFolderDeleteMutation,
  moduleFolderStructureMutation,
  moduleFolderStructureOptions,
  moduleFolderStructureQueryKey,
  moduleFolderTemplateAppendMutation,
  moduleFolderTemplateAppendOptions,
  moduleFolderTemplateAppendQueryKey,
  moduleFolderTemplateDeleteMutation,
  moduleFolderTemplateUpdateMutation,
  moduleFolderUpdateMutation,
  moduleFoldersStructureMutation,
  moduleFoldersStructureOptions,
  moduleFoldersStructureQueryKey,
  modulePermissionGrantAllMutation,
  modulePermissionGrantMutation,
  modulePermissionRevokeMutation,
  moduleRelationsGetOptions,
  moduleRelationsGetQueryKey,
  moduleRelationsUpdateMutation,
  moduleRelationsUpdateOptions,
  moduleRelationsUpdateQueryKey,
  moduleRootFolderCreateMutation,
  moduleRootFolderCreateOptions,
  moduleRootFolderCreateQueryKey,
  moduleSettingGetOptions,
  moduleSettingGetQueryKey,
  moduleSettingsGetOptions,
  moduleSettingsGetQueryKey,
  moduleSettingsUpdateMutation,
  moduleTemplatesPermissionGrantAllMutation,
  moduleUpdateMutation,
  modulesOptions,
  modulesQueryKey,
  organizationAccountOptions,
  organizationAccountQueryKey,
  organizationAccountsMutation,
  organizationAccountsOptions,
  organizationAccountsQueryKey,
  organizationBookingsMutation,
  organizationBookingsOptions,
  organizationBookingsQueryKey,
  organizationCreateMutation,
  organizationCreateOptions,
  organizationCreateQueryKey,
  organizationDeleteMutation,
  organizationListOptions,
  organizationListQueryKey,
  organizationOptions,
  organizationQueryKey,
  organizationTreeForTenantOptions,
  organizationTreeForTenantQueryKey,
  organizationTreeOptions,
  organizationTreeQueryKey,
  organizationUpdateMutation,
  performFileUploadMutation,
  productPriceDeleteMutation,
  productPriceMostRelevantOptions,
  productPriceMostRelevantQueryKey,
  productPriceUpsertMutation,
  productPriceUpsertOptions,
  productPriceUpsertQueryKey,
  productPricesListMutation,
  productPricesListOptions,
  productPricesListQueryKey,
  proxyImageOptions,
  proxyImageQueryKey,
  recordActionApplyMutation,
  recordActionApplyOptions,
  recordActionApplyQueryKey,
  recordActionClassifyMutation,
  recordActionClassifyOptions,
  recordActionClassifyQueryKey,
  recordActionCreateFromMutation,
  recordActionCreateFromOptions,
  recordActionCreateFromQueryKey,
  recordAssignmentCreateMutation,
  recordAssignmentCreateOptions,
  recordAssignmentCreateQueryKey,
  recordAssignmentDeleteMutation,
  recordAssignmentUpdateMutation,
  recordAssignmentsMutation,
  recordAssignmentsOptions,
  recordAssignmentsQueryKey,
  recordBookingsMutation,
  recordBookingsOptions,
  recordBookingsQueryKey,
  recordCreateMutation,
  recordCreateOptions,
  recordCreateQueryKey,
  recordEventsMutation,
  recordEventsOptions,
  recordEventsQueryKey,
  recordExplicitRelationCreateMutation,
  recordExplicitRelationCreateOptions,
  recordExplicitRelationCreateQueryKey,
  recordExplicitRelationDeleteMutation,
  recordExplicitRelationListMutation,
  recordExplicitRelationListOptions,
  recordExplicitRelationListQueryKey,
  recordExplicitRelationUpdateMutation,
  recordFilesPermissionUpdateMutation,
  recordFollowupListMutation,
  recordFollowupListOptions,
  recordFollowupListQueryKey,
  recordIndividualPermissionCreateMutation,
  recordIndividualPermissionCreateOptions,
  recordIndividualPermissionCreateQueryKey,
  recordIndividualPermissionDeleteMutation,
  recordIndividualPermissionListMutation,
  recordIndividualPermissionListOptions,
  recordIndividualPermissionListQueryKey,
  recordIndividualPermissionUpdateMutation,
  recordOptions,
  recordPriorityCreateMutation,
  recordPriorityCreateOptions,
  recordPriorityCreateQueryKey,
  recordPriorityDeleteMutation,
  recordPriorityOptions,
  recordPriorityQueryKey,
  recordPrioritySetCreateMutation,
  recordPrioritySetCreateOptions,
  recordPrioritySetCreateQueryKey,
  recordPrioritySetDeleteMutation,
  recordPrioritySetOptions,
  recordPrioritySetPrioritiesOptions,
  recordPrioritySetPrioritiesQueryKey,
  recordPrioritySetPriorityCreateMutation,
  recordPrioritySetPriorityCreateOptions,
  recordPrioritySetPriorityCreateQueryKey,
  recordPrioritySetQueryKey,
  recordPrioritySetUpdateMutation,
  recordPriorityUpdateMutation,
  recordQueryKey,
  recordStatusCreateMutation,
  recordStatusCreateOptions,
  recordStatusCreateQueryKey,
  recordStatusDeleteMutation,
  recordStatusOptions,
  recordStatusQueryKey,
  recordStatusSetCreateMutation,
  recordStatusSetCreateOptions,
  recordStatusSetCreateQueryKey,
  recordStatusSetDeleteMutation,
  recordStatusSetOptions,
  recordStatusSetQueryKey,
  recordStatusSetStatusCreateMutation,
  recordStatusSetStatusCreateOptions,
  recordStatusSetStatusCreateQueryKey,
  recordStatusSetStatusesOptions,
  recordStatusSetStatusesQueryKey,
  recordStatusSetUpdateMutation,
  recordStatusUpdateMutation,
  recordUpdateMutation,
  recordVersionsMutation,
  recordVersionsOptions,
  recordVersionsQueryKey,
  recordsAggregateMutation,
  recordsAggregateOptions,
  recordsAggregateQueryKey,
  recordsCountMutation,
  recordsCountOptions,
  recordsCountQueryKey,
  recordsDeleteMutation,
  recordsMinimalMutation,
  recordsMinimalOptions,
  recordsMinimalQueryKey,
  recordsMutation,
  recordsOptions,
  recordsPurgeMutation,
  recordsQueryKey,
  recordsRestoreMutation,
  recordsRestoreOptions,
  recordsRestoreQueryKey,
  removeRecordCategoriesMutation,
  roleCreateMutation,
  roleCreateOptions,
  roleCreateQueryKey,
  roleListForOrganizationOptions,
  roleListForOrganizationQueryKey,
  roleListForTenantOptions,
  roleListForTenantQueryKey,
  rolePermissionOptions,
  rolePermissionQueryKey,
  roleRemoveMutation,
  roleUpdateMutation,
  roleUserListOptions,
  roleUserListQueryKey,
  settingGetOptions,
  settingGetQueryKey,
  settingPermissionGrantAllMutation,
  settingPermissionGrantMutation,
  settingPermissionRevokeMutation,
  settingsGetOptions,
  settingsGetQueryKey,
  simpleTenantUpdateMutation,
  systemSettingGetOptions,
  systemSettingGetQueryKey,
  systemSettingsOptions,
  systemSettingsQueryKey,
  tagCreateMutation,
  tagCreateOptions,
  tagCreateQueryKey,
  tagDeleteMutation,
  tagUpdateMutation,
  tagsMutation,
  tagsOptions,
  tagsQueryKey,
  templateCopyMutation,
  templateCopyOptions,
  templateCopyQueryKey,
  templateCreateMutation,
  templateCreateOptions,
  templateCreateQueryKey,
  templateDeleteMutation,
  templateKindCopyMutation,
  templateKindCopyOptions,
  templateKindCopyQueryKey,
  templateKindCreateMutation,
  templateKindCreateOptions,
  templateKindCreateQueryKey,
  templateKindDeleteMutation,
  templateKindGetOptions,
  templateKindGetQueryKey,
  templateKindListOptions,
  templateKindListQueryKey,
  templateKindSectionListOptions,
  templateKindSectionListQueryKey,
  templateKindSectionUpsertMutation,
  templateKindUpdateMutation,
  templateOptions,
  templatePatchMutation,
  templatePermissionGrantAllMutation,
  templatePermissionGrantMutation,
  templatePermissionRevokeMutation,
  templateQueryKey,
  templateRecordPrioritiesOptions,
  templateRecordPrioritiesQueryKey,
  templateRecordStatusesOptions,
  templateRecordStatusesQueryKey,
  templateSectionCreateMutation,
  templateSectionCreateOptions,
  templateSectionCreateQueryKey,
  templateSectionDeleteMutation,
  templateSectionFieldBlockCreateMutation,
  templateSectionFieldBlockCreateOptions,
  templateSectionFieldBlockCreateQueryKey,
  templateSectionFieldBlockDeleteMutation,
  templateSectionFieldBlockGetOptions,
  templateSectionFieldBlockGetQueryKey,
  templateSectionFieldBlockListOptions,
  templateSectionFieldBlockListQueryKey,
  templateSectionFieldBlockUpdateMutation,
  templateSectionGetOptions,
  templateSectionGetQueryKey,
  templateSectionListOptions,
  templateSectionListQueryKey,
  templateSectionUpdateMutation,
  templateUpdateMutation,
  templatesMutation,
  templatesOptions,
  templatesQueryKey,
  tenantAccountSeedMutation,
  tenantAccountsMutation,
  tenantAccountsOptions,
  tenantAccountsQueryKey,
  tenantBookingsMutation,
  tenantBookingsOptions,
  tenantBookingsQueryKey,
  tenantConfigCheckMutation,
  tenantConfigCheckOptions,
  tenantConfigCheckQueryKey,
  tenantConfigCreateMutation,
  tenantConfigCreateOptions,
  tenantConfigCreateQueryKey,
  tenantConfigDeleteMutation,
  tenantConfigGetOptions,
  tenantConfigGetQueryKey,
  tenantConfigListOptions,
  tenantConfigListQueryKey,
  tenantConfigUpdateMutation,
  tenantCopyStructureMutation,
  tenantCopyStructureOptions,
  tenantCopyStructureQueryKey,
  tenantCreateMutation,
  tenantCreateOptions,
  tenantCreateQueryKey,
  tenantManagementInitializeMutation,
  tenantOptions,
  tenantQueryKey,
  tenantRecordPrioritySetCreateMutation,
  tenantRecordPrioritySetCreateOptions,
  tenantRecordPrioritySetCreateQueryKey,
  tenantRecordPrioritySetsOptions,
  tenantRecordPrioritySetsQueryKey,
  tenantRecordStatusSetCreateMutation,
  tenantRecordStatusSetCreateOptions,
  tenantRecordStatusSetCreateQueryKey,
  tenantRecordStatusSetsOptions,
  tenantRecordStatusSetsQueryKey,
  tenantUpdateMutation,
  tenantUsageOptions,
  tenantUsageQueryKey,
  tenantsForMeOptions,
  tenantsForMeQueryKey,
  tenantsListOptions,
  tenantsListQueryKey,
  treeFolderMutation,
  treeFolderOptions,
  treeFolderQueryKey,
  updateFileFolderMutation,
  updateRecordUpdatedMetadataMutation,
  userCreateMutation,
  userCreateOptions,
  userCreateQueryKey,
  userDeleteMutation,
  userGetOptions,
  userGetQueryKey,
  userGroupListOptions,
  userGroupListQueryKey,
  userMeOptions,
  userMeQueryKey,
  userRoleChangeMutation,
  userRoleListOptions,
  userRoleListQueryKey,
  userSecretsMutation,
  userSecretsOptions,
  userSecretsQueryKey,
  userSettingGetOptions,
  userSettingGetQueryKey,
  userSettingUpdateMutation,
  userSettingsGetOptions,
  userSettingsGetQueryKey,
  userSettingsUpdateMutation,
  userUpdateMutation,
  usergroupAddMutation,
  usergroupAddOptions,
  usergroupAddQueryKey,
  usergroupByIdOptions,
  usergroupByIdQueryKey,
  usergroupMemberListOptions,
  usergroupMemberListQueryKey,
  usergroupMembersModifyMutation,
  usergroupRemoveMutation,
  usergroupRoleListOptions,
  usergroupRoleListQueryKey,
  usergroupRolesModifyMutation,
  usergroupUpdateMutation,
  usergroupsForTenantOptions,
  usergroupsForTenantQueryKey,
  usersForTenantOptions,
  usersForTenantQueryKey,
  vatRateCreateMutation,
  vatRateCreateOptions,
  vatRateCreateQueryKey,
  vatRateOptions,
  vatRateQueryKey,
  vatRateUpdateMutation,
  vatRatesDeleteMutation,
  vatRatesMutation,
  vatRatesOptions,
  vatRatesQueryKey
};
//# sourceMappingURL=vue-query.gen.js.map